import ACCOUNT from './account'

const PRICING = {
  PRICING: ACCOUNT.ACCOUNT_PACKAGE
}

export default PRICING
